import { services } from '@ambita/ambita-components-core';

services.i18n.registerTranslations('login', {
  nb: {
    loginBtn: 'Logg in',
    logoutBtn: 'Logg ut',
    usernameLabel: 'Brukernavn',
    passwordLabel: 'Passord'
  },
  'en-us': {
    loginBtn: 'Login',
    logoutBtn: 'Logout',
    usernameLabel: 'Username',
    passwordLabel: 'Password'
  }
});
